export default "/app/themes/majeures/build/images/avatar3.svg?0f1db70eb9a863020231c2d5d275d45e";